import env from "@/configs/env"
const apiConfig = `${env.urlApi}${env.enpoint}`;
export default apiConfig;